import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'




// import "video.js/dist/video-js.css";
// import video_zhCN from "video.js/dist/lang/zh-CN.json";
// import videoJS from "video.js";
// videoJS.addLanguage("zh-CN", video_zhCN); //设置播放器的语言

// import TCPlayer from 'tcplayer.js';
// import 'tcplayer.js/dist/tcplayer.min.css';
// locale.use(TCPlayer);




import '@fortawesome/fontawesome-free/css/all.css'

import axios from 'axios'
Vue.prototype.axios = axios

//设置语言名
import locale from 'element-ui/lib/locale';
import en from 'element-ui/lib/locale/lang/en'; // 引入英文语言包
// 设置ElementUI的语言
locale.use(en);

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/display.css';
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false
Vue.use(ElementUI)

import httpinfo from './assets/js/httpinfo.js'
Vue.prototype.httpinfo = httpinfo
Vue.use(httpinfo)

import VueMeta from 'vue-meta';
Vue.use(VueMeta);

Vue.prototype.baseURL = 'https://api.komovie.xyz/user_api2/'
Vue.prototype.baseMark = 'bbtv'


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
